import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Route from 'cio/routes/base';
import ObjectsListController from './controller';
import FiltersService from 'cio/services/filters';
import DS from 'ember-data';
import Transition from '@ember/routing/-private/transition';
import ObjectTypeModel from 'cio/models/object-type';

export default class ListRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  queryParams = {
    filters: {
      refreshModel: true,
    },
    page: {
      refreshModel: true,
    },
    name: {
      refreshModel: true,
    },
  };

  model(params: Record<string, string>) {
    let objectType = this.modelFor('objects.type') as ObjectTypeModel;

    let queryParams = { ...params };

    return this.store.query('object', {
      ...queryParams,
      objectTypeId: objectType.id,
    });
  }

  setupController(controller: ObjectsListController, model: ReturnType<DS.Store['query']>, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.setupController(this.modelFor('objects.type') as ObjectTypeModel, model);
    controller.settings.cleanupAttributesFromSettings(
      'objectTypeColumns',
      controller.objectType.sentAttributes,
      controller.objectType.id,
    );
  }

  resetController(controller: ObjectsListController, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.showColumnsModal = false;
      controller.page = 1;
    }
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
